import React from 'react';
import styles from './flex.module.scss';
import {Alignment} from '../../enums/alignment.ts';

interface OwnProps {
    children: React.ReactNode;
    alignment?: Alignment;
    grow?: number;
}

export function FlexColumn({children, alignment, grow}: OwnProps) {
    const flexClass = () => {
        switch (alignment) {
            case Alignment.Start:
                return 'flex-start';
            case Alignment.End:
                return 'flex-end';
            default:
                return 'center';
        }
    };
    return (
        <div className={styles.flex_column} style={{justifyContent: flexClass(), flexGrow: grow ?? 'unset'}}>
            {children}
        </div>
    );
}
